<template>
    <div>

<!--        <div class="header-btn">-->
<!--            <el-button size="mini" type="warning" @click="syncDoor" icon="el-icon-refresh"></el-button>-->
<!--        </div>-->
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <property-selector :value.sync="queryForm.propertyId"></property-selector>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.displayName" clearable placeholder="Display Name"></el-input>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
            </el-form>
        </div>
        <el-table
                v-loading="loading"
                fit
                highlight-current-row
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'id',label:'ID',wth:'140px'},
                        {prop:'propertyName',label:'Property Name',wth:'140px'},
                        {prop:'displayName',label:'Display Name',wth:'140px'},
                        {prop:'sip',label:'Mac',wth:'140px'},
                        {prop:'facilityId',label:'Facility',wth:'140px'},
                        {prop:'doorType',label:'Type',wth:'140px',fmt:doorTypeFmt},
                        {prop:'ranking',label:'Ranking',wth:'140px'},
                        {prop:'showLock',label:'Show Lock',wth:'140px',fmt:boolFormat},
                        {prop:'showQr',label:'Show QR',wth:'140px',fmt:boolFormat},
                        {prop:'updated',label:'Updated',wth:'140px',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="primary" icon="el-icon-edit" circle @click="edit(s.row)"></el-button>
                    <el-button type="danger" icon="el-icon-delete" circle @click="deleteRow(s.row.id)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                title="Edit Door Info"
                center
                :visible.sync="dialogVisible"
                width="40%">
            <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
                <el-form-item label="Replace with">
                    <el-input v-model="form.replace"
                              placeholder="Type in a mac address, and the system will use this intercom to update the current record"></el-input>
                </el-form-item>
                <el-form-item prop="displayName" label="Display Name">
                    <el-input v-model="form.displayName" placeholder="Display Name"></el-input>
                </el-form-item>

                <el-form-item prop="ranking" label="Ranking">
                    <el-input-number v-model="form.ranking" :min="0" :max="100000"></el-input-number>
                </el-form-item>

                <el-form-item prop="doorType" label="Type">
                    <el-select v-model="form.doorType">
                        <el-option
                                v-for="item in doorTypes"
                                :key="item.val+'door'"
                                :label="item.lab"
                                :value="item.val">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="facilityId" label="Facility">
                    <el-input v-model="form.facilityId"></el-input>
                </el-form-item>
                <el-form-item prop="showLock" label="Display lock button">
                    <el-checkbox v-model="form.showLock"></el-checkbox>
                </el-form-item>

                <el-form-item prop="showQr" label="Display QR button">
                    <el-checkbox v-model="form.showQr"></el-checkbox>
                </el-form-item>

                <el-form-item prop="iconId" label="Icon">
                    <icon-uploader :url="form.iconPath" :fid.sync="form.iconId"></icon-uploader>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">Save</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
             </span>
        </el-dialog>
    </div>
</template>

<script>
import {doorSync, doors, updateDoor, deleteDoor} from '@/api/eazableAPI'
import IconUploader from "@/components/IconUploader";
import {deleteRequest} from "@/utils/ApiUtils";
import PropertySelector from "@/components/PropertySelector";

export default {
    name: "Door",
    components: {PropertySelector, IconUploader},
    data: function () {
        return {
            doorTypes: [
                {val: 1, lab: 'Gate'},
                {val: 2, lab: 'Door'},
                {val: 3, lab: 'Side Gate'},
                {val: 4, lab: 'Vehicle Barrier'},
            ],
            doorTypeObj: {},
            dialogVisible: false,
            isCreate: false,
            form: {},
            queryForm: {},
            loading: false,
            data: [],
            page: {'page': 1, 'size': 20, 'totalPage': 1, 'total': 0},
            rules: {}
        }
    },
    methods: {
        doorTypeFmt(row, cel, val) {
            return this.doorTypeObj[val]
        },
        boolFormat(row, cel, val) {
            return val ? 'True' : 'False'
        },
        edit(form) {
            this.form = form
            this.dialogVisible = true
        },
        saveData() {
            const form = {
                displayName: this.form.displayName,
                ranking: this.form.ranking,
                showLock: this.form.showLock,
                showQr: this.form.showQr,
                iconId: this.form.iconId,
                replace: this.form.replace,
                doorType: this.form.doorType,
                facilityId: this.form.facilityId
            }
            updateDoor(this.form.id, form)
                .then(() => {
                    this.loadData()
                    this.dialogVisible = false
                })

        },
        deleteRow(id) {
            deleteRequest(this, deleteDoor, id)
        },
        loadData() {
            this.$pageUtils(this, doors)
        },
        syncDoor() {
            if (confirm("Please confirm there is a new install intercom, not replace an old one, if you want to replace the old one, please use edit.")) {
                if (confirm('Start doors syncing with door control system task ? This will need about more than 1m,don`t refreshing the windows when the task started!!!')) {
                    this.loading = true;
                    doorSync().then(() => this.loadData());
                }
            }
        }
    },
    mounted() {
        this.loadData()
        this.doorTypes.forEach(it => {
            this.doorTypeObj[it.val] = it.lab
        })
    }
}
</script>

<style scoped>
.el-button {
    margin-right: 5px;
}
</style>
